import React, { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const ChartLoadingSkeleton: FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Chart Area Skeleton */}
      <Skeleton variant="rectangular" width="100%" height={400} sx={{ flex: 1, borderRadius: 1 }} />

      {/* Legend/Checkboxes Skeleton */}
      <Stack direction="row" spacing={2}>
        {[...Array(3)].map((_: unknown, i: number) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={100}
            height={24}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Stack>
    </Box>
  );
};
